var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.nomeSaleChannel)+" - Plataforma Para Gestão de Recebíveis!")])]),_c('p',[_vm._v("© "+_vm._s(_vm.year)+" "+_vm._s(_vm.nomeSaleChannel)+" ©")])])
}
var staticRenderFns = []

export { render, staticRenderFns }